import { useState, useEffect, useCallback } from "react";
import "./ClockIn.scss";
import dayjsTZ from "../../../../utils/dayjs";
import YesterdayInfo from "./YesterdayInfo";
import { useAuth } from "../../../../authentication/authHelpers";
import NewUserShift from "./NewUserShift";
import { useSelector } from "react-redux";
import ClockInActive from "./ClockInActive";
import ClockOutActive from "./ClockOutActive";
import { HollowDotsSpinner } from "react-epic-spinners";
import { API } from "aws-amplify";
import axios from "axios";
import { isAllowedIP } from "./isAllowedIP";

// const { TextArea } = Input;
// const { Text } = Typography;
const IP_WHITELIST_FIELD_ID = "4fgtf65fgf-mnjlsdfv-89000nmnbhujj";

const ClockIn = () => {
  const auth = useAuth();

  const [{ isDarkMode }, { clockings }, { programFields }] = useSelector(
    (state) => [state.usersList, state.clockings, state.programFields],
  );

  const [showYesterday, setShowYesterday] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [newShift, setNewShift] = useState(true);
  const [loading, setLoading] = useState(true);
  // const [shiftLog, setShiftLog] = useState(false);
  const [time, setTime] = useState(dayjsTZ());
  // const [customTime, setCustomTime] = useState(false);
  const [editedTime, setEditedTime] = useState(null);
  const [whiteListError, setWhiteListError] = useState(false);
  const [notes, setNotes] = useState({ clockInNote: "", clockOutNote: "" });
  const [shift, setShift] = useState({
    userId: "374d3f3rfsdfsff4r834239421rfsdfdsr33",
    employeeId: null,
    clockInDate: "",
    clockOutDate: "",
    createdAt: dayjsTZ().valueOf(),
  });
  const [loadingColor, setLoadingColor] = useState("#1da193");
  const [shiftConfiguration, setShiftConfiguration] = useState({
    applicableShifts: [],
    appliedShifts: {},
  });
  const [autoSuggestion, setAutoSuggestion] = useState(null);

  // const toggleShiftLog = (val) => {
  //   setShiftLog(val);
  // };
  const resetValues = () => {
    setEditedTime(null);
    setNotes({ clockInNote: "", clockOutNote: "" });
  };
  // const onCustomStartTime = (val) => {
  //   if (dayjsTZ(val).format("HH:mm") !== dayjsTZ(time).format("HH:mm")) {
  //     if (!!val && dayjsTZ().unix() > dayjsTZ(val).unix()) {
  //       setEditedTime(val);
  //     } else {
  //       message.error("Ti nuk mund të zgjedhësh një orë në të ardhmen.");
  //     }
  //   } else if (dayjsTZ(val).format("HH:mm") === dayjsTZ(time).format("HH:mm")) {
  //     setEditedTime(null);
  //     setNotes({ clockInNote: "", clockOutNote: "" });
  //   }
  // };
  // const onCustomEndTime = (val) => {
  //   const prevClockIn = apiData[apiData.length - 1]?.clockInDate;
  //   if (prevClockIn !== null) {
  //     if (dayjsTZ(val).format("HH:mm") !== dayjsTZ(time).format("HH:mm")) {
  //       if (
  //         !!val &&
  //         dayjsTZ().unix() > dayjsTZ(val).unix() &&
  //         dayjsTZ(val).unix() > dayjsTZ(prevClockIn).unix()
  //       ) {
  //         setEditedTime(val);
  //       } else {
  //         message.error(
  //           `Ti nuk mund të zgjedhësh kete orar! ${dayjsTZ(val).format(
  //             "HH:mm"
  //           )}. Orari i përfundimit duhet të jetë mbas fillimit të turnit!`
  //         );
  //       }
  //     } else if (dayjsTZ(val).format("HH:mm") === dayjsTZ(time).format("HH:mm")) {
  //       setEditedTime(null);
  //       setNotes({ clockInNote: "", clockOutNote: "" });
  //     }
  //   } else {
  //     message.error("Ndodhi një gabim!");
  //   }
  // };
  // Get all shifts from the database and sort according to clock in date! (ascending)
  //region LOAD SHIFT DATA
  const loadShiftData = useCallback(
    async (emplId) => {
      // await getShifts(emplId).then((result) => {
      // 	// console.log("result", result);
      // 	if (result) {
      // 		setApiData(result?.sort((a, b) => a?.clockInDate - b?.clockInDate) || []);
      // 	}
      // });
      const clockinsData =
        clockings
          ?.filter((el) => el?.employeeId === emplId)
          ?.sort((a, b) => a?.clockInDate - b?.clockInDate) || [];
      const color =
        clockinsData[clockinsData.length - 1]?.clockInDate !== null &&
        clockinsData[clockinsData.length - 1]?.clockOutDate !== null
          ? "#1da193"
          : "#ea3943";
      setApiData(clockinsData);
      setLoadingColor(color);
      await API.get("shifts", "/shifts").then((res) => {
        if (Array.isArray(res)) {
          let shiftsAppl = auth?.employee?.employeeShiftId || [];
          let allShifts = [];

          if (shiftsAppl.length > 0) {
            shiftsAppl?.forEach((el) => {
              allShifts.push(res?.find((e) => e?.shiftId === el));
            });
          }
          setShiftConfiguration({
            applicableShifts: [...res],
            appliedShifts: allShifts,
          });
        }
      });
      if (loading) {
        setLoading(false);
      }
    },
    [clockings],
  );

  //region HANDLE CLOCKOUT
  // const handleClockOut = async (shift, val, type) => {
  //   // let lastShift = await getLastShift();http://localhost:3000/punonjesit
  //   if (!!shift?.employeeId) {
  //     let lastShift = getLastOnGoingShift(apiData);
  //     if (!!lastShift.clockingId) {
  //       // * @EneaXharau - Set loading color to red
  //       setLoadingColor("#ea3943");
  //       setLoading(true);
  //       if (type === "single") {
  //         await endShift(lastShift, shift, val);
  //         await loadShiftData(shift.employeeId);
  //         setNewShift(false);
  //         resetValues();
  //         setLoading(false);
  //         swal({
  //           title: `Turni u përfundua me sukses në orën ${dayjsTZ(val).format(
  //             "HH:mm"
  //           )}!`,
  //           icon: "success",
  //           className: "custum-swal",
  //           // confirmButtonText
  //         });
  //       } else {
  //         await endDoubleShift(lastShift, shift, val);
  //         await loadShiftData(shift.employeeId);
  //         setNewShift(false);
  //         resetValues();
  //         setLoading(false);
  //         swal({
  //           title: `Turni u përfundua me sukses në orën ${dayjsTZ(val).format(
  //             "HH:mm"
  //           )}!`,
  //           icon: "success",
  //           className: "custum-swal",
  //         });
  //       }

  //       notificationUserToAdminNoDbPost(
  //         {
  //           notificationTitle: "Mbaroi Turni",
  //           createdAt: dayjsTZ().format("DD/MM/YYYY"),
  //           notificationCategory: "Info",
  //           notificationPriority: false,
  //           notificationBody: `${auth?.userAccess[0]?.given_name} ${
  //             auth?.userAccess[0]?.family_name
  //           } mbaroi turnin ${dayjsTZ(val).format("HH:mm")} `,
  //           isAnnouncement: false,
  //           notificationUrl: "/aprovimet",
  //           notificationFirstName: auth?.userAccess[0]?.given_name,
  //           notificationLastName: auth?.userAccess[0]?.family_name,
  //         },
  //         users?.allUsers.Items
  //       );
  //     }
  //     setLoading(false);
  //   }
  // };
  const onShiftNote = (e, key) => {
    setNotes((prev) => ({ ...prev, [key]: e.target.value }));
  };

  // Decides whether to clock out a single shift
  // In the case where the time is past midnight, it slices the shift into two! (before 8 am)

  // const onClockOut = async () => {
  //   if (
  //     dayjsTZ(apiData[apiData.length - 1]?.clockInDate).format("DD/MM/YYYY") ===
  //     dayjsTZ().format("DD/MM/YYYY")
  //   ) {
  //     let clockOut;
  //     if (editedTime !== null) {
  //       if (notes?.clockOutNote !== "") {
  //         clockOut = {
  //           category: "manual",
  //           employeeId: shift.employeeId,
  //           clockOutNote: notes?.clockOutNote,
  //           editedClockOut: true,
  //           finishedAt: dayjsTZ().valueOf(),
  //           approved: false,
  //         };
  //         await handleClockOut(clockOut, editedTime, "single");
  //       } else {
  //         message.error("Ju duhet të vendosni një shënim.");
  //       }
  //     } else if (editedTime === null) {
  //       clockOut = {
  //         category: "automatic",
  //         editedClockOut: false,
  //         employeeId: shift.employeeId,
  //         clockOutNote: notes?.clockOutNote,
  //         // finishedAt:  dayjsTZ().valueOf(),
  //         finishedAt: dayjsTZ(autoSuggestion).valueOf(),
  //         approved: false,
  //       };
  //       await handleClockOut(clockOut, autoSuggestion, "single");
  //     }
  //     // console.log("Clock out!", clockOut);
  //   } else if (
  //     dayjsTZ(apiData[apiData.length - 1]?.clockOutDate).format("DD/MM/YYYY") !==
  //     dayjsTZ().format("DD/MM/YYYY")
  //   ) {
  //     let today = dayjsTZ();
  //     today.set({
  //       hour: "08",
  //       minute: "00",
  //       second: "00",
  //     });
  //     if (dayjsTZ().valueOf() < dayjsTZ(today).valueOf()) {
  //       let clockOut;
  //       if (editedTime !== null) {
  //         if (notes?.clockOutNote !== "") {
  //           clockOut = {
  //             category: "manual",
  //             employeeId: shift.employeeId,
  //             clockOutNote: notes?.clockOutNote,
  //             editedClockOut: true,
  //             finishedAt: dayjsTZ().valueOf(),
  //             approved: false,
  //           };
  //           await handleClockOut(clockOut, editedTime, "double");
  //         } else {
  //           message.error("Ju duhet të vendosni një shënim.");
  //         }
  //       } else if (editedTime === null) {
  //         clockOut = {
  //           category: "automatic",
  //           editedClockOut: false,
  //           employeeId: shift.employeeId,
  //           clockOutNote: notes?.clockOutNote,
  //           finishedAt: dayjsTZ().valueOf(),
  //           approved: false,
  //         };
  //         await handleClockOut(clockOut, time, "double");
  //       }
  //     } else {
  //       setShowForgot(true);
  //     }
  //   }
  // };

  // When the last shift is not closed and current time is after 8am
  // const onClockForgot = async (obj) => {
  //   const { isAfterMidnight } = obj;
  //   // console.log("Obj", obj);
  //   let clockForgot = {
  //     employeeId: shift.employeeId,
  //     editedClockOut: true,
  //     forgotClockOut: true,
  //     clockOutNote: obj.shenimi,
  //     finishedAt: dayjsTZ().valueOf(),
  //     approved: false,
  //   };

  //   if (
  //     dayjsTZ(obj.fillimi).format("DD/MM/YYYY") !==
  //     dayjsTZ(obj.mbarimi).format("DD/MM/YYYY")
  //   ) {
  //     // let diff = moment.duration(obj.mbarimi.diff(obj.fillimi)).asDays();
  //     let date = dayjsTZ(obj.fillimi);
  //     const time = dayjsTZ(obj.mbarimi);
  //     date = date
  //       .set("hour", time.get("hour"))
  //       .set("minute", time.get("minute"))
  //       .set("second", "00");
  //     // console.log("Diferenca", diff);
  //     // let editedClockOut = dayjsTZ(obj.mbarimi).subtract(diff, "days").valueOf();
  //     if (isAfterMidnight) {
  //       await handleClockOut(clockForgot, time, "double");
  //     } else {
  //       await handleClockOut(clockForgot, date, "single");
  //     }
  //   }
  // };

  // Function that determines the auto suggestion for clock out
  const getTime = (time) => {
    // let time = dayjsTZ(time);
    let l_dayjs = dayjsTZ();
    l_dayjs = l_dayjs.set("hour", "21").set("minute", "15").set("second", "00");

    let h_dayjs = dayjsTZ();
    h_dayjs.set("hour", "21").set("minute", "31").set("second", "00");

    let autoSuggestion = dayjsTZ();
    autoSuggestion = autoSuggestion
      .set("hour", "21")
      .set("minute", "30")
      .set("second", "00");

    let lower_bound = dayjsTZ(l_dayjs).valueOf();
    let upper_bound = dayjsTZ(h_dayjs).valueOf();
    if (
      dayjsTZ(time).valueOf() > lower_bound &&
      dayjsTZ(time).valueOf() < upper_bound
    ) {
      setShift((prev) => ({ ...prev, clockOutDate: autoSuggestion }));
      return autoSuggestion;
    } else {
      return dayjsTZ();
      // return autoSuggestion;
    }
  };

  const getIpFallback = async () => {
    let deviceIP;
    try {
      const res = await axios.get("https://api.ipify.org/?format=json");
      deviceIP = res.data.ip;
    } catch (e) {
      deviceIP = "NOT_FOUND";
    }
    return deviceIP;
  };

  const validateWhiteListed = async () => {
    let whiteList, deviceIP;

    const idx = programFields.findIndex(
      (el) => el.fieldId === IP_WHITELIST_FIELD_ID,
    );

    if (idx !== -1) {
      whiteList = programFields[idx].fieldOptions?.whiteList || [];

      try {
        const res = await API.get("getIp", "/getIp");
        deviceIP = (res || "").split(",")[0];
        if (!deviceIP) {
          deviceIP = await getIpFallback();
        }
      } catch {
        deviceIP = await getIpFallback();
      }
    }

    setWhiteListError(false);

    if (whiteList.length > 0) {
      if (!deviceIP || deviceIP === "NOT_FOUND") {
        setWhiteListError("Adresa juaj IP nuk u gjet.");
        return;
      }

      if (
        !isAllowedIP(
          deviceIP,
          whiteList.map((el) => el.ip),
        )
      ) {
        setWhiteListError("Adresa juaj IP nuk është në listën e lejuar.");
        return;
      }
    }

    setWhiteListError(false);
  };

  // Retrieving data from the API
  // * @EneaXharau - Added clockings dependency to update between
  // * tabs of the same user
  useEffect(() => {
    if (!!auth.employeeId && !!clockings) {
      setShift((prev) => ({ ...prev, employeeId: auth.employeeId }));
      loadShiftData(auth.employeeId);
    }
  }, [auth?.employeeId, clockings]);

  // Used for updating time indicator
  useEffect(() => {
    if (!programFields) return;

    const validateAsync = async () => {
      await validateWhiteListed();
    };

    validateAsync();
  }, [programFields]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(dayjsTZ());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  // Used to suggest clock out time
  useEffect(() => {
    let timeout;
    if (!!autoSuggestion) {
      timeout = setTimeout(() => {
        setAutoSuggestion(getTime(autoSuggestion));
      }, 60000);
    } else {
      setAutoSuggestion(getTime(dayjsTZ()));
    }
    return () => clearTimeout(timeout);
  }, [autoSuggestion]);

  //region RETURN
  return (
    <div
      className="clockinBackground"
      style={{
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      {/* <Button onClick={onTest}>TEST</Button> */}
      {loading === true ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <HollowDotsSpinner color={loadingColor} size={24} />
        </div>
      ) : (
        <>
          <div
            className={`clock-in ${
              apiData[apiData.length - 1]?.clockInDate !== null &&
              apiData[apiData.length - 1]?.clockOutDate !== null
                ? "clockinBackgroundBlue"
                : "clockinBackgroundRed"
            } ${isDarkMode ? "dark" : ""}`}
          >
            {apiData[apiData.length - 1]?.clockInDate !== null &&
            apiData[apiData.length - 1]?.clockOutDate !== null &&
            newShift === true ? (
              <ClockInActive
                {...{
                  // time,
                  editedTime,
                  // customTime,
                  // onCustomStartTime,
                  // setCustomTime,
                  whiteListError,
                  setShowConfirm,
                  setShowYesterday,
                  notes,
                  onShiftNote,
                  // shiftConfiguration,
                }}
              />
            ) : (
              <ClockOutActive
                {...{
                  // time,
                  editedTime,
                  apiData,
                  // loading,
                  // customTime,
                  // autoSuggestion,
                  // onCustomEndTime,
                  // setCustomTime,
                  notes,
                  whiteListError,
                  // onClockOut,
                  onShiftNote,
                  // setLoading,
                  setLoadingColor,
                  loadShiftData,
                  resetValues,
                  setNewShift,
                  shiftConfiguration,
                }}
              />
            )}
          </div>
        </>
      )}
      {showYesterday && (
        <YesterdayInfo
          handleYesterday={(val) => setShowYesterday(val)}
          showYesterday={showYesterday}
          shift={shift}
          userData={auth}
        />
      )}
      {/* <Confirmation
        clockInTime={dayjsTZ()}
        showConfirm={showConfirm}
        handleShowConfirm={(val) => setShowConfirm(val)}
        confirmModal={handleClockIn}
        {...{ editedTime }}
      /> */}
      {/* {showConfirm && ( */}
      <NewUserShift
        selfType={true}
        selectedEmployee={null}
        newShiftVisib={showConfirm}
        setNewShiftVisib={setShowConfirm}
        setPrevShift={setNewShift}
        liveTime={time}
        onRefresh={resetValues}
        shiftConfiguration={shiftConfiguration}
      />
      {/* )} */}
      {/* {shiftLog && (
        <ClockShiftLog
          shiftLog={shiftLog}
          toggleShift={() => toggleShiftLog()}
        />
      )} */}
      {/* {showForgot && (
        <Forgot
          handleForgot={(val) => setShowForgot(val)}
          showForgot={showForgot}
          {...{ userData: auth, shift, apiData, onClockForgot }}
        />
      )} */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "10px",
          backgroundColor: loadingColor,
          borderBottomLeftRadius: "10px",
          borderBottomRightRadius: "10px",
        }}
      />
    </div>
  );
};
export default ClockIn;
